interface TypeaheadEditableCellScope extends ng.IScope {
  choose                 : ( item : any, row : any, type : any ) => void;
  handleBlur             : ( e : JQuery.TriggeredEvent ) => void;
  handleDocumentKeydown  : ( e : JQuery.TriggeredEvent ) => void;
  handleDocumentMousedown: ( e : JQuery.TriggeredEvent ) => void;
  handleDocumentMouseup  : ( e : JQuery.TriggeredEvent ) => void;
  handleKeydown          : ( e : JQuery.TriggeredEvent ) => void;
  init                   : ( context : any, row : any ) => void;
}

export function TypeaheadEditableCellDirective (
  $document: ng.IDocumentService,
  $timeout : ng.ITimeoutService,
  KEYCODES : any
) {
  return {
    restrict: 'A',
    require : 'ngModel',
    link ( scope : TypeaheadEditableCellScope, element : ng.IRootElementService, attrs : ng.IAttributes, ctrl : ng.INgModelController ) {
      let _lastClicked, _context, _row, _originalModel;

      scope.choose = function ( item : any, row : any, type : any ) : void {
        const parent = $('.ngCell').has(element[0]);

        type.choose(item, row);

        $timeout(() => {
          scope.$emit('ngGridEventEndCellEdit', true);

          parent.nextAll()
            .has('[ng-cell-has-focus]:not(.disabled)')
            .find('[ng-cell-has-focus]')
            .first()
            .trigger('click');
        });
      };

      scope.handleBlur = function ( e : JQuery.TriggeredEvent ) : void {
        if ( element.parent().find(_lastClicked).length < 1 ) {
          scope.$emit('ngGridEventEndCellEdit');
        }
      }

      scope.handleDocumentKeydown = function ( e : JQuery.TriggeredEvent ) : void {
        _lastClicked = angular.element(e.target);
      }

      scope.handleDocumentMousedown = function ( e : JQuery.TriggeredEvent ) : void {
        _lastClicked = angular.element(e.target);
      };

      scope.handleDocumentMouseup = function ( e : JQuery.TriggeredEvent ) : void {
        _lastClicked = null;
      };

      scope.handleKeydown = function ( e : JQuery.TriggeredEvent ) : void {
        const keys = KEYCODES;

        /**
         * FIRST CASE
         * If the user has tabbed out of the field
         * AND there is a set _context for the search
         * object AND no item has been selected yet
         * AND there is a quickSearch function,
         * do the quick search and choose the item
         * if there is one found
         *
         * SECOND CASE
         * if the user has tabbed out of the field and
         * there IS an item selected already BUT
         * the new value for the field is different from the old
         * then we need to do a quick search as well.
         */
        if ( (e.keyCode === keys.tab &&
          !e.shiftKey &&
          _context &&
          !_row.entity[_context.identifier] &&
          _context.quickSearch) || // first case
          (e.keyCode  === keys.tab && //second case
          _row.entity[_context.identifier] &&
          _originalModel !== ctrl.$modelValue &&
          _context.quickSearch
        )) {
          _context.quickSearch(ctrl.$modelValue)
          .then(( item : any ) => {
            scope.choose(item, _row, _context);
          })
          .catch(( err : any ) => angular.noop());

          e.preventDefault();
          e.stopPropagation();
        }

        // If we already have an item selected, just tab normally.
        else if (e.keyCode === keys.tab && _row.entity[attrs.identifier]) {
          $timeout(() => scope.$emit('ngGridEventEndCellEdit'));
        }

        // Stop propagation on arrows so ng-grid doesn't ruin my life
        else if (e.keyCode === keys.left ||
          e.keyCode === keys.right ||
          e.keyCode === keys.up ||
          e.keyCode === keys.down
        ) {
          e.stopPropagation();
        }

        // "Enter" and "Home" do weird things when were editing these fields, not on my watch
        else if (e.keyCode === keys.home
          || e.keyCode === keys.enter)
        {
          e.preventDefault();
        }
      };

      /**
       * Called on input focus. Sets the _context of the
       * typeahead (the search object that it is
       * using from the controller) and keeps a reference
       * to the original data.
       */
      scope.init = function( context : any , row : any ) : void {
        _context = context;
        _row     = row;

        if (_row.entity[_context.identifier]) {
          _originalModel = ctrl.$modelValue;
        }
      };

      $document.on('keydown', null, scope.handleDocumentKeydown);
      $document.on('mousedown', null, scope.handleDocumentMousedown);
      $document.on('mouseup', null, scope.handleDocumentMouseup);

      element.on('blur', scope.handleBlur);
      element.on('keydown', scope.handleKeydown);

      scope.$on('$destroy', () => {
        $document.off('keydown', null, scope.handleDocumentKeydown);
        $document.off('mousedown', null, scope.handleDocumentMousedown);
        $document.off('mouseup', null, scope.handleDocumentMouseup);

        element.off('blur', scope.handleBlur);
        element.off('keydown', scope.handleKeydown);
      })

      scope.$on('ngGridEventEndCellEdit', ( evt : any, allowUpdate : boolean ) => {
        /**
         * If we have a _context and no item has been
         * selected, clear out any typed value
         */
        if (_context && !_row.entity[_context.identifier]) {
          ctrl.$setViewValue('');
          ctrl.$render();
        }

        /**
         * if there is an item that has been selected AND
         * the original value was not blank (an item was
         * selected before this focus) AND the original
         * value doesn't match the current, reset the value
         * to the original because evidentally a new item
         * was not found this time.
         */
        else if (_context &&
          !allowUpdate &&
          _row.entity[_context.identifier] &&
          _originalModel &&
          _originalModel !== ctrl.$modelValue
        ) {
          ctrl.$setViewValue(_originalModel);
          ctrl.$render();
        }
      });

      scope.$on('ngGridEventStartCellEdit', () => {
        element.trigger('focus');
      });
    }
  };
}